import React from "react";

import { IssueParent } from "@common/models/issueTracking";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { TicketKeyCopy } from "@main/pages/shared/components/TicketKey/TicketKey";
import * as Icon from "@main/pages/shared/icons/icons";
import { RoutePaths } from "@main/router/config/routePaths";
import { generatePath, Link } from "react-router-dom";

import * as Styled from "./DuplicateOf.styles";

interface Props {
  parent: IssueParent;
}

/** "Duplicate of <parent>" above the details bar, linking to the ticket this one duplicates. */
export const DuplicateOf = ({ parent }: Props) => {
  const { selectedWorkspace, selectedApp } = useAppSelectionContext();

  return (
    <Styled.Container>
      <Icon.DuplicateIcon />
      <span>
        Duplicate of{" "}
        <Link
          to={generatePath(RoutePaths.USER_FEEDBACK_DETAILS, {
            workspaceSlug: selectedWorkspace?.slug ?? null,
            appKey: selectedApp?.key ?? null,
            userFeedbackKey: parent.key.toString(),
          })}
        >
          {parent.pretty_title}
        </Link>
      </span>
      <TicketKeyCopy
        ticketKey={parent.key.toString()}
        enableCopy={false}
      />
    </Styled.Container>
  );
};
